import { BaseConfig } from '@fpkg/stats-core';
import WebSensorsConfig from './WebSensorsConfig';

export const DefaultAPPCodeForSFAPM = '9ed59c5d6b9a40d794adff6d71dced05';
export const DefaultTestAPPCodeForSFAPM = 'b998e09fb5334bf8873d6e1ff61f56e0';
export default class WebStatsConfig extends BaseConfig {
  sensorsConfig: WebSensorsConfig = new WebSensorsConfig();

  plugins: Record<string, object | boolean> = {
    jsError: true,
    resourceError: true,
    blankScreen: true,
    ajax: true,
    performance: true,
    moduleExposure: true,
    pageView: true,
    acsp: false,
    sfapm: {
      appCode: DefaultAPPCodeForSFAPM,
    },
    sflogs: false, // 默认不上报顺丰云日志，必须要配置logUrl 开启
  };
}
